import { useField, useFormikContext } from "formik";
import { Form as SemanticForm, Label } from "semantic-ui-react";
import React from "react";
import Fuse from "fuse.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const Form = ({ children, ...props }) => {
  const { handleReset, handleSubmit } = useFormikContext();

  return (
    <SemanticForm onSubmit={handleSubmit} onReset={handleReset} {...props}>
      {children}
    </SemanticForm>
  );
};

export const FormInput = (props) => {
  const [field, meta, helpers] = useField(props);

  return (
    <SemanticForm.Input
      onChange={(e, v) => helpers.setValue(v.value)}
      value={field.value.value}
      error={meta.touched && meta.error ? meta.error : null}
      {...props}
    />
  );
};

export const FormDateInput = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <SemanticForm.Field error={!!(meta.touched && meta.error)}>
      <label>{label}</label>
      <DatePicker
        // locale="pt-BR"
        dateFormat="dd/MM/yyyy"
        placeholderText="dd/mm/aaaa"
        onChange={helpers.setValue}
        selected={field.value}
        {...props}
      />
      {meta.touched && meta.error ? (
        <Label pointing prompt>
          {meta.error}
        </Label>
      ) : null}
    </SemanticForm.Field>
  );
};

export const FormTextArea = (props) => {
  const [field, meta, helpers] = useField(props);

  return (
    <SemanticForm.TextArea
      onChange={(e, v) => helpers.setValue(v.value)}
      value={field.value.value}
      error={meta.touched && meta.error ? meta.error : null}
      {...props}
    />
  );
};

export const FormCheckbox = (props) => {
  const [field, meta, helpers] = useField(props);

  return (
    <SemanticForm.Checkbox
      onChange={(e, v) => {
        helpers.setValue(v.checked);
      }}
      checked={field.value}
      value={field.value}
      error={meta.touched && meta.error ? meta.error : null}
      {...props}
    />
  );
};

export const FormSelect = (props) => {
  const [field, meta, helpers] = useField(props);

  return (
    <SemanticForm.Select
      onChange={(e, v) => helpers.setValue(v.value)}
      value={field.value.value}
      error={meta.touched && meta.error ? meta.error : null}
      search={(options, query) => {
        const fuse = new Fuse(options, { keys: ["value", "text"] });
        const results = fuse.search(query);
        return results.map((e) => e.item);
      }}
      {...props}
    />
  );
};
